import React from "react"
import { Link } from "gatsby"

const CustomLink = props => {
  const internal = /^\/(?!\/)/.test(props.path)

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <Link className={props.extraClass} to={props.path}>
        <span>{props.title}</span>
      </Link>
    )
  }

  return (
    <a
      className={props.extraClass}
      href={props.path}
      target="_blank"
      rel="noreferrer"
    >
      <span>{props.title}</span>
    </a>
  )
}

export default CustomLink
